import router from "@/router";
import Global from "./Global";
import HttpResponse from "./vo/HttpResponse";
import Config from "./Config";
import { showConfirmDialog, showDialog, showNotify } from "vant";
import ad_account from "./vo/dbvo/ad_account";
import { ColorEnum, ResultCodeEnum } from "./SuperEnum";
import { isRef, Ref } from "vue";
import { SSEResponse } from "./vo/SSEResponse";
import html2canvas from "html2canvas";
import App from "@/App.vue";
import { useRoute } from "vue-router";
var SparkMD5 = require('spark-md5');


export type MediaType =
    | "*/*"
    | "image/*"
    | "video/*"
    | "audio/*"
    | "font/*"
    | "game/*"
    | ".png"
    | ".jpeg"
    | ".jpg"
    | ".svg"
    | ".gif"
    | ".webp"
    | ".bmp"
    | ".svg+xml"
    | ".mp4"
    | ".webm"
    | ".ogg"
    | ".mp3"
    | ".wav"
    | ".ogg"
    | ".pdf"
    | ".txt"
    | ".html"
    /**
     * OpenType 是一种字体格式，由 Microsoft 和 Adobe 共同开发。.oft 是 OpenType 字体的文件扩展名之一。OpenType 字体可以使用 TrueType 或 PostScript 字形轮廓（这两种轮廓类型支持矢量字形，因此可以无损缩放）。
     * 浏览器支持较差，通常需要转换成 Web 格式（如 .woff）来加载。  
     */
    | ".otf"
    /**
     * FFT 是 FontForge 字体编辑器生成的 TrueType 字体格式文件扩展名。FontForge 是一个开源的字体编辑工具，支持多种字体格式的编辑和创建，包括 TrueType 和 OpenType。
     * 浏览器对 .fft 的支持较差，通常不会直接使用这种格式。
     */
    | ".ttf"
    /**
     * WOFF 是一种为 Web 环境设计的字体格式，它基于 OpenType 或 TrueType 字体格式，并进行压缩，以适应 Web 使用。WOFF 格式允许浏览器高效加载字体，并能减少网络请求的文件大小。
     * 由于是压缩格式，可能会牺牲一些字体文件的质量。
     */
    | ".woff"
    /**
     * WOFF2 是 WOFF 的后继版本，采用了更高效的压缩算法（Brotli 压缩），进一步减小了文件大小，并且在加载性能上有所提升。
     * 相较于 .woff，WOFF2 的兼容性稍差，某些旧版本的浏览器（如 Internet Explorer）不支持
     */
    | ".woff2" //
    | ".obj"
    | ".stl"
    | ".fbx"
    | ".collada"
    | ".3ds"
    | ".x"
    | ".blender"
    | ".bvh"
    | ".gltf"
    | ".glb"
    | ".unitypackage"
    | ".mmd"
    | ".vox"
    | ".ue4-scene"
    | ".dwg"
    | ".dxf"
    | ".iges"
    | ".step"
    | ".vdb"
    | ".x3d"
    | ".cinema4d"
    | ".lwo"
    | ".smd"
    | ".tmd";


/**
 * 工具类
 */
export default class Tools {


    /**
     * 生成GUID
     */
    public static get GUID(): string {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return 'G_' + (S4() + S4() + "" + S4() + "" + S4() + "" + S4() + "" + S4() + S4() + S4());
    }


    // /**
    //  * 设置值
    //  * @param obj 
    //  * @param value 
    //  */
    // public static SetValue<T>(obj: T | Ref<T>, key: keyof T, value: any) {
    //     if (isRef(obj)) {
    //         (obj as any)[key].value = value;
    //     }
    //     else {
    //         (obj as any)[key] = value;
    //     }
    // }

    /**
     * 调用函数
     * @param obj 
     * @param key 
     * @param value 
     */
    public static CallValue<T>(obj: T | Ref<T>, key: keyof T, ...prom: any[]) {
        if (isRef(obj)) {
            (obj as any)[key].value(prom);
        }
        else {
            (obj as any)[key](prom);
        }
    }

    // /**
    //  * 获取值
    //  * @param obj 
    //  * @param value 
    //  */
    // public static GetValue<T, TOut>(obj: T | Ref<T>, key: keyof T, defalutValue: TOut): TOut {
    //     if (isRef(obj)) {
    //         return (obj as any)[key].value ?? defalutValue;
    //     }
    //     else {
    //         return (obj as any)[key] ?? defalutValue;
    //     }
    // }



    /**
     * 获取网络文件
     * @param url 请求地址
     * @param method 模式
     * @param body 数据
     * @param [checkTimeOut=false] 是否检查超时
     */
    public static async FetchGetFileAsync(url: string, body: any, method: "POST" | "GET" | "DELETE" | "PUT" | "PATCH",
        ContentType: 'application/json' | 'text/plain' | 'multipart/form-data' | 'application/x-www-form-urlencoded' = 'application/json',
        Headers: { [key: string]: any }
    ): Promise<Blob> {
        switch (method) {
            case "GET":
            case "DELETE":
                break;
            default:
                break;
        }

        let fetchBody: BodyInit | undefined
        switch (method) {
            case "GET":
            case "DELETE":
                delete Headers['Content-Type'];
                if (body != null && Object.keys(body).length > 0)
                    url += '?';
                for (const key in body) {
                    url += `${key}=${encodeURIComponent(body[key])}&`;
                }
                if (url.endsWith('&'))
                    url = url.substring(0, url.length - 1);
                break;
            default:
                switch (ContentType) {
                    case "application/json":
                        fetchBody = JSON.stringify(body);
                        break;
                    case "application/x-www-form-urlencoded":
                        const urlSearchParams = new URLSearchParams();
                        Object.keys(body).forEach(key => {
                            urlSearchParams.append(key, String(body[key]));
                        });
                        fetchBody = urlSearchParams.toString();
                        break;
                    case "multipart/form-data":
                        delete Headers['Content-Type'];
                        const formData = new FormData();
                        Object.keys(body).forEach(key => {
                            formData.append(key, body[key]);
                        });
                        fetchBody = formData;
                        break;
                    case "text/plain":
                        fetchBody = typeof body === "string" ? body : JSON.stringify(body);
                        break;
                }
                break;
        }
        return new Promise(r => {
            globalThis.fetch(url, {
                headers: Headers,
                method: method,
                body: fetchBody
            }).then(resp => {

                //#region 经过类型处理

                //#endregion

                return resp.blob();
            }).then(v => {
                r(v);
            });
        });
    }


    /**
     * Get请求
     * @param action 
     * @param getContent 
     * @returns 
     */
    public static FetchGetAsync<T = any>(action: string, getContent: any) {
        return this.FetchAsync<T>(action, getContent, "GET", "text/plain");
    }


    /**
     * 获取SSE数据
     * @param action 
     * @param body 
     * @param OnStreamFun 
     */
    public static async FetchSSEAsync(action: string, body: any, OnStreamFun: (data: SSEResponse | '[DONE]') => void): Promise<void> {
        const TAG: string = "FetchSSEAsync";
        let url = Global.GetAPIUrl(action);
        globalThis.fetch(url, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${Global.JwtToken.value}`,
                'Content-Type': 'application/json',
            },
            body: typeof body == "string" ? body : JSON.stringify(body)
        }).then(response => {
            if (!response.ok)
                throw new Error('网络未准备好!');
            const reader = response.body?.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            reader?.read().then(function processStream({ done, value }) {
                if (done) {
                    '流读取完毕'.Log(TAG, ColorEnum.Success);
                    return;
                }
                buffer += decoder.decode(value, { stream: true });
                // 解析数据块，按行分割每条事件
                let boundary = buffer.indexOf('\n\n');
                while (boundary !== -1) {

                    // 取出完整的事件数据
                    const eventData = buffer.slice(0, boundary).trim();
                    buffer = buffer.slice(boundary + 2); // 删除已处理的部分

                    // 解析每个事件（例如，将数据转为 JSON）
                    const eventLines = eventData.split('\n');

                    for (let i = 0; i < eventLines.length; i++) {
                        const dataStr = eventLines[i];
                        //解码数据
                        let v = dataStr.substring('data: '.length);

                        switch (v) {
                            case '[DONE]':
                                OnStreamFun && OnStreamFun(v);
                                break;
                            default:
                                const responseData = JSON.parse(v);
                                Object.setPrototypeOf(responseData, SSEResponse.prototype);
                                OnStreamFun && OnStreamFun(responseData);
                                break;
                        }

                    }

                    // const eventObj: { [key: string]: string } = {};
                    // eventLines.forEach(line => {
                    //     const [key, value] = line.split(':');
                    //     if (key && value) {
                    //         eventObj[key.trim()] = value.trim();
                    //     }
                    // });

                    // console.log('读取到数据流:', eventObj);
                    // Tools.ShowLog(TAG,'')

                    // 继续读取流
                    boundary = buffer.indexOf('\n\n');
                }

                // 继续读取流中的数据
                reader.read().then(processStream);
            }).catch(error => {
                '错误的流读取'.Log("FetchSSEAsync", ColorEnum.Error);
            })
        }).catch(ex => {
            typeof ex == "string" ? ex : ex?.message ?? '未知错误!'.Log(TAG, ColorEnum.Error);
        });
    }

    /**
     * 进行网络请求
     * @param action 具体指令
     * @param method 模式
     * @param body 数据
     * @param [checkTimeOut=false] 是否检查超时
     */
    public static async FetchAsync<T = any>(action: string, body: any, method: "POST" | "GET" | "DELETE" | "PUT" | "PATCH",
        ContentType: 'application/json' | 'text/plain' | 'multipart/form-data' | 'application/x-www-form-urlencoded' = 'application/json',
        noCheckTimeOut: boolean = false
    ): Promise<HttpResponse<T>> {
        let url = Global.GetAPIUrl(action);

        if (!noCheckTimeOut) {
            //尝试刷新Token
            if (!await Global.ToRefreshTokenAsync()) {
                const errResp = new HttpResponse<T>();
                errResp.Code = ResultCodeEnum.UnAuthorized;
                errResp.Message = "刷新登录失败";
                errResp.Success = false;
                return errResp;
            }
        }
        //#endregion


        const headers: HeadersInit = {
            "Authorization": `Bearer ${Global.JwtToken.value}`,
            "Content-Type": ContentType
        };
        switch (method) {
            case "GET":
            case "DELETE":
                break;
            default:
                break;
        }

        for (const key in body) {
            if (Object.prototype.hasOwnProperty.call(body, key)) {
                const v = body[key];
                if (v == null || v == undefined) {
                    delete body[key];
                }
            }
        }


        let fetchBody: BodyInit | undefined
        switch (method) {
            case "GET":
            case "DELETE":
                delete headers['Content-Type'];
                if (body != null && Object.keys(body).length > 0)
                    url += '?';
                for (const key in body) {
                    url += `${key}=${encodeURIComponent(body[key])}&`;
                }
                if (url.endsWith('&'))
                    url = url.substring(0, url.length - 1);
                break;
            default:
                switch (ContentType) {
                    case "application/json":
                        fetchBody = JSON.stringify(body);
                        break;
                    case "application/x-www-form-urlencoded":
                        const urlSearchParams = new URLSearchParams();
                        Object.keys(body).forEach(key => {
                            urlSearchParams.append(key, String(body[key]));
                        });
                        fetchBody = urlSearchParams.toString();
                        break;
                    case "multipart/form-data":
                        delete headers['Content-Type'];
                        const formData = new FormData();
                        Object.keys(body).forEach(key => {
                            const v = body[key];
                            if (typeof v == "object") {
                                if ('length' in v) {
                                    for (let i = 0; i < v.length; i++) {
                                        formData.append(key, v[i]);
                                    }
                                }
                                else {
                                    formData.append(key, v);
                                }
                            }
                            else {
                                formData.append(key, v);
                            }
                        });
                        fetchBody = formData;
                        break;
                    case "text/plain":
                        fetchBody = typeof body === "string" ? body : JSON.stringify(body);
                        break;
                }
                break;
        }
        return new Promise(r => {
            globalThis.fetch(url, {
                headers: headers,
                method: method,
                body: fetchBody
            }).then(response => {

                //#region 进行类型处理
                const contentType = response.headers.get("Content-Type");
                if (contentType) {
                    if (contentType.includes('application/json')) {
                        // 处理 JSON 数据
                        return response.json();
                    } else if (contentType.includes('text/')) {
                        // 处理文本数据
                        return response.text();
                    } else if (contentType.includes('image/')) {
                        // 处理图片数据
                        return response.blob();
                    } else if (contentType.includes('audio/') || contentType.includes('video/')) {
                        // 处理音频或视频数据
                        return response.blob();;
                    } else {
                        // 处理其他类型的数据，默认作为 Blob 处理
                        return response.blob();
                    }
                }
                else {
                    // 没有 Content-Type 的情况
                    const blobData = response.blob();
                    return { type: 'unknown', data: blobData };
                }
                //#endregion
            }).then(v => {

                if (v instanceof Blob) {
                    const nResp = new HttpResponse<T>();
                    nResp.Code = 200;
                    nResp.Success = true;
                    nResp.Message = "";
                    nResp.Data = v as any as T;
                    r(nResp);
                    return;
                }
                else if (typeof v == "string") {
                    v = JSON.parse(v);
                }
                Object.setPrototypeOf(v, HttpResponse.prototype);
                r(v);
            });
        });
    }

    /**
     * 获取当前时间戳
     */
    public static get GetNowTime(): number {
        return Date.now();
    }

    /**
     * 获取当前的Post传参
     * @returns 
     */
    public static GetParams<T = any>(): T {
        return history.state.data ?? {} as T;
    }



    /**
     * 选择文件
     * @param multiple 是否多选 
     * @returns 
     */
    public static SelectFilesAsync(accept: MediaType[] = ['*/*'], multiple: boolean = false): Promise<FileList | null> {
        return new Promise(r => {
            try {
                const win = globalThis;
                const select_file_name: string = 'select_file_name';
                let input: HTMLInputElement | null = win.document.querySelector(`input[name='${select_file_name}']`);
                if (!input) {
                    input = win.document.createElement("input");
                    input.type = "file";
                    input.name = select_file_name; // 设置文件字段名称
                    // 监听文件选择事件
                    input.addEventListener('change', (event) => {
                        const files = input!.files;
                        // 返回文件列表
                        r(files);
                    });
                }
                input.multiple = multiple;
                input.accept = accept.join(',');
                // 自动触发文件选择框
                input.click();
            }
            catch (e) {
                r(null);
            }
        });
    }

    /**
     * 转换成MD5
     * @param v 
     * @returns 
     */
    static ToMd5(v: string): string {
        const md5 = new SparkMD5();
        md5.appendBinary(v);
        return md5.end();
    }

    /**
     * 设置对象
     * @param to_obj 
     * @param from_obj 
     */
    static SetObj(to_obj: any, from_obj: any) {
        if (to_obj == null)
            to_obj = {};
        if (to_obj && from_obj) {
            for (const key in from_obj) {
                if (Object.prototype.hasOwnProperty.call(from_obj, key)) {
                    const v = from_obj[key];
                    to_obj[key] = v;
                }
            }
        }
    }


    static IsJson(arg0: string): boolean {
        try {
            if (JSON.parse(arg0))
                return true;
        }
        catch (e) {

        }
        return false;
    }

    /**
     * 是否为JSON数组
     * @param arg0 
     * @returns 
     */
    static IsJsonArr(arg0: string) {

        let item = this.ToJsonVO(arg0);
        if (!item.flag)
            return false;
        if (((item.data?.hasOwnProperty("length") ?? null)))
            return true;
        return false;
    }

    /**
     * 检测是否为空
     * @param v 
     * @returns 
     */
    public static IsNull(v: (string | undefined) | (string | null)): boolean {
        if (v == null || v == "null" || v == undefined || v == "undefined" || v == "")
            return true;
        return false;
    }

    /**
     * 是否不是空
     * @param v 
     * @returns 
     */
    public static IsNotNull(v: (string | undefined) | (string | null)): boolean {
        return !this.IsNull(v);
    }


    /**
     * 获取本地存储
     * @param key 
     * @returns 
     */
    public static GetLocalStorage(key: string, _default: string): string {
        let v = localStorage.getItem(key);
        if (Tools.IsNull(key))
            return "";
        return v as string;
    }

    /**
    * 设置本地存储
    * @param key 
    * @param v 
    */
    public static SetLocalStorage(key: string, v: string): void {
        localStorage.setItem(key, v);
    }

    /**
     * 删除键
     * @param key 
     */
    public static RemoveLocalStorage(key: string): void {
        localStorage.removeItem(key);
    }

    /**
     * 清空存储键
     */
    public static ClearLocalStorage() {
        localStorage.clear();
    }


    /**
     * 弹出失败消息
     * @param ERROR_MESSAGE 
     */
    static AlertError(ERROR_MESSAGE: string | undefined) {
        showNotify({
            type: "danger",
            message: ERROR_MESSAGE
        });
    }

    /**
     * 弹出成功消息
     * @param SUCCESS_MESSAGE 
     */
    static AlertSuccess(SUCCESS_MESSAGE: string): void {
        showNotify({
            type: "success",
            message: SUCCESS_MESSAGE
        });
    }

    /**
     * 弹出提示框
     * @param title 
     * @param content 
     * @param confirm 
     * @param cancel 
     */
    static MessageBox(title: string, content: string, confirm: () => void, cancel?: () => void) {
        showConfirmDialog({
            title: title,
            message: content,
        }).then(() => {
            confirm && confirm();
        }).catch(() => {
            cancel && cancel();
        })
    }


    static ToJsonVO(str: string): {
        flag: boolean,
        data: any
    } {
        try {
            return {
                flag: true,
                data: JSON.parse(str)
            };
        }
        catch (ex) {
            return {
                flag: false,
                data: null
            }
        }
    }

    /**
     * 跳转页面
     * @param href 
     * @param replace 
     */
    public static GoTo(href: string, replace: boolean = false, query?: { [key: string]: any }, params?: { [key: string]: any }) {
        router.push({
            path: href,
            replace: replace,
            query: query,
            state: {
                data: params
            }
        });
    }

    /**
     * 返回
     */
    public static ToBack() {
        history.back();
    }


    private static Base64UrlDecode(input: string): string {
        // 替换 URL 特殊字符
        input = input.replace(/-/g, '+').replace(/_/g, '/');
        // 添加必要的填充符号
        const pad = input.length % 4;
        if (pad) {
            input += '='.repeat(4 - pad);
        }
        // 使用 atob 解码为二进制字符串
        const binary = atob(input);
        // 将二进制字符串转换为字节数组
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        // 使用 TextDecoder 解码为 UTF-8 字符串
        const decoder = new TextDecoder('utf-8');
        return decoder.decode(bytes);
    }

    /**
     * 解析 JWT
     * @param {string} token - JWT 字符串
     * @returns {{ header: Object, payload: Object, signature: string }} 解析后的 JWT 部分
     */
    public static ParseJWT(token: string): {
        header: {
            alg: string,
            typ: string
        },
        payload: {
            iss: string,
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string,
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string,
            "exp": number,
            "aud": string,
            "UserInfo": ad_account
        },
        signature: string
    } {
        if (!token) {
            throw new Error("JWT Token 错误!");
        }

        const parts = token.split('.');

        if (parts.length !== 3) {
            throw new Error("无效的 JWT token");
        }

        const [encodedHeader, encodedPayload, signature] = parts;

        // 解码 Header 和 Payload
        const decodedHeader = this.Base64UrlDecode(encodedHeader);
        const decodedPayload = this.Base64UrlDecode(encodedPayload);

        // 解析 JSON
        const header = JSON.parse(decodedHeader);
        const payload = JSON.parse(decodedPayload);
        if (typeof payload.UserInfo == 'string')
            payload.UserInfo = JSON.parse(payload.UserInfo);
        return {
            header,
            payload,
            signature
        };
    }

    /**
     * 显示LOG
     * @param tag 标签
     * @param msg 日志内容
     * @param color 颜色
     * @param font_size 字体大小
    */
    public static ShowLog(tag: string, msg: any, color: ColorEnum = ColorEnum.Info, font_size: number = 12): void {
        console.log(`%c【${tag}】:${msg}`, `color:${color};font-size:${font_size}px`);
    }

    /**
     * 获取参数
     * @param paramName 属性名称
     * @returns 
     */
    public static GetQueryParam(paramName: string) {
        let location = globalThis.location;
        let urlParams = new URLSearchParams(location.search);
        let paramValue = urlParams.get(paramName);
        return paramValue
    }

    /**
     * 等待运行
     * @param ms 
     * @returns 
     */
    public static async SleepAsync(ms: number): Promise<void> {
        return new Promise((r) => {
            setTimeout(() => {
                r();
            }, ms);
        });
    }


    /**
     * 根据宽度计算毫秒数
     * @param currentWidth 
     * @param totalWidth 
     * @param totalMilliseconds 
     * @returns 
     */
    public static CalculateMillisecondsFromWidth(currentWidth: number, totalWidth: number, totalMilliseconds: number): number {
        // 按比例计算当前宽度对应的毫秒数
        const milliseconds = (currentWidth / totalWidth) * totalMilliseconds;
        return milliseconds;
    }

    /**
     * 根据毫秒数计算像素值
     * @param milliseconds 具体的毫秒数
     * @param pxPerSecond 每秒的像素单位多少PX
     * @returns 
     */
    public static CalculatePxFromMilliseconds(milliseconds: number, pxPerSecond: number = 100): number {
        // 计算秒数并乘以每秒的px单位
        const seconds = milliseconds / 1000;
        const widthInPx = seconds * pxPerSecond;
        return widthInPx;
    }

    /**
     * 格式化数组时间到字符串
     * @param arr 
     * @param format 
     * @returns 
     */
    public static FormatArrDateToString(arr: any[] | any[][], format: "yyyy-MM-dd" | "yyyy-MM" | "yyyy/MM/dd" | "yyyy/MM" | "yyyy-MM-dd HH:mm:ss" | "HH:mm:ss") {
        switch (format) {
            case "HH:mm:ss":
                switch (arr.length) {
                    case 3:
                        return `${arr[0]}:${arr[1]}:${arr[2]}`;
                    case 2:
                        return `${arr[0]}:${arr[1]}`;
                    default:
                        return "无法解析";
                }
                break;
            case "yyyy-MM-dd HH:mm:ss":

                switch (arr.length) {
                    case 6:
                        return `${arr[0]}-${arr[1]}-${arr[2]} ${arr[3]}:${arr[4]}:${arr[5]}`;
                    case 5:
                        return `${arr[0]}-${arr[1]}-${arr[2]} ${arr[3]}:${arr[4]}`;
                    case 3:
                        return `${arr[0]}-${arr[1]}-${arr[2]}`;
                    case 2:
                        if (arr[0] instanceof Array) {
                            let allStr = '';
                            switch (arr[0].length) {
                                case 3:
                                    allStr = `${arr[0][0]}-${arr[0][1]}-${arr[0][2]}`;
                                    break;
                                case 2:
                                    allStr = `${arr[0][0]}-${arr[0][1]}`;
                                    break;
                                default:
                                    return "日期无法解析!";
                            }
                            switch (arr[1].length) {
                                case 3:
                                    allStr += ` ${arr[1][0]}:${arr[1][1]}:${arr[1][2]}`;
                                    break;
                                case 2:
                                    allStr += ` ${arr[1][0]}:${arr[1][1]}`;
                                    break;
                                default:
                                    return "时间无法解析!";
                            }
                            return allStr;
                        }
                        else {
                            return `${arr[0]}-${arr[1]}`;
                        }
                        break;
                    default:
                        return "无法解析"
                }

                if (arr.length == 6) {

                }
                else if (arr.length == 2) {

                }
                else {
                    return "无法解析";
                }
                break;
            case "yyyy/MM":
            case "yyyy-MM":
                if (arr.length == 2) {
                    if (format == "yyyy-MM") {
                        return `${arr[0]}-${arr[1]}`;
                    }
                    else if (format == "yyyy/MM") {
                        return `${arr[0]}/${arr[1]}`;
                    }
                }
                return "无法解析";
                break;
            case "yyyy/MM/dd":
            case "yyyy-MM-dd":
                if (arr.length >= 3) {
                    if (format == "yyyy-MM-dd") {
                        return `${arr[0]}-${arr[1]}-${arr[2]}`;
                    }
                    else {
                        return `${arr[0]}/${arr[1]}/${arr[2]}`;
                    }

                }
                else if (arr.length == 2) {
                    if (format == "yyyy-MM-dd") {
                        return `${arr[0]}-${arr[1]}`;
                    }
                    else {
                        return `${arr[0]}/${arr[1]}`;
                    }
                }
                else {
                    return "无法解析";
                }
                break;
        }
    }

    /**
     * 格式化毫秒数
     * @param seconds 
     */
    public static FormatTimeWithMilliseconds(milliseconds: number, format: "HH:mm:ss.fff||mm:ss.fff" | "HH:mm:ss||mm:ss" | "HH:mm:ss.fff" | "HH:mm:ss" | "HH:mm" | "HHmmss" | "mm:ss" | "mmss" | "ss" | "fff") {
        // 计算小时
        let hours: number | string = (Math.floor(milliseconds / (3600 * 1000)));
        // 计算分钟
        let minutes: number | string = Math.floor((milliseconds % (3600 * 1000)) / (60 * 1000));
        // 计算剩余的秒数
        let seconds: number | string = Math.floor((milliseconds % (60 * 1000)) / 1000);
        //计算毫秒数
        let remainingMilliseconds: number | string = Math.floor(milliseconds % 1000);

        const str_hours = hours.toString().padStart(2, '0');
        const str_minutes = minutes.toString().padStart(2, '0');
        const str_seconds = seconds.toString().padStart(2, '0');
        const str_remainingMilliseconds = remainingMilliseconds.toString().padStart(3, '0');

        switch (format) {
            case "HH:mm:ss.fff||mm:ss.fff":
                if (hours > 0) {
                    return `${str_hours}:${str_minutes}:${str_seconds},${str_remainingMilliseconds}`;
                }
                else {
                    return `${str_minutes}:${str_seconds}.${str_remainingMilliseconds}`;
                }
            case "HH:mm:ss||mm:ss":
                if (hours > 0) {
                    return `${str_hours}:${str_minutes}:${str_seconds}`;
                }
                else {
                    return `${str_minutes}:${str_seconds}`;
                }
            case "HH:mm:ss.fff":
                return `${str_hours}:${str_minutes}:${str_seconds}.${str_remainingMilliseconds}`;
            case "HH:mm:ss":
                return `${str_hours}:${str_minutes}:${str_seconds}`;
            case "HH:mm":
                return `${str_hours}:${str_minutes}`;
            case "HHmmss":
                return `${str_hours}${str_minutes}${str_seconds}`;
            case "mm:ss":
                return `${str_minutes}:${str_seconds}`;
            case "mmss":
                return `${str_minutes}${str_seconds}`;
            case "ss":
                return `${str_seconds}`;
            case "fff":
                return `${str_remainingMilliseconds}`;
        }
    }

    /**
     * 时间戳转换成时间格式
     * @param timestamp 时间戳
     * @param format 格式化
     * @returns 
     */
    public static ConvertTimestamp(timestamp: number,
        format: "[yyyy,MM,dd]" | "[HH,mm]" | "[HH,mm,ss]" | "yyyy-MM-dd HH:mm:ss" | "yyyy/MM/dd HH:mm:ss" | "yyyyMMddHHmmss" | "yyyy-MM-dd" | "yyyy/MM/dd" | "yyyyMMdd" | "HH:mm:ss" | "HHmmss" | "mm:ss" | "HH:mm" = "yyyy-MM-dd HH:mm:ss"
    ) {
        if (typeof timestamp !== 'number') {
            return "未知";
        }

        // 判断时间戳是否为秒级或毫秒级
        if (timestamp > 1e8 && timestamp < 1e12) { // 小于1,000,000,000,000，假设为秒级
            timestamp *= 1000; // 转换为毫秒级
        }
        const date = new Date(timestamp);

        if (isNaN(date.getTime())) {
            return '未知';
        }

        // 获取各部分，并补零
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
        const day = String(date.getDate()).padStart(2, '0');

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        switch (format) {
            case "mm:ss":
                return `${minutes}:${seconds}`;
            case "HH:mm":
                return `${hours}:${minutes}`;
            case "HH:mm:ss":
                return `${hours}:${minutes}:${seconds}`;
            case "HHmmss":
                return `${hours}${minutes}${seconds}`;
            case "yyyy-MM-dd":
                return `${year}-${month}-${day}`;
            case "yyyy-MM-dd HH:mm:ss":
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            case "yyyy/MM/dd":
                return `${year}/${month}/${day}`;
            case "yyyy/MM/dd HH:mm:ss":
                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            case "yyyyMMdd":
                return `${year}${month}${day}`;
            case "[yyyy,MM,dd]":
                return [year, month, day];
            case "[HH,mm,ss]":
                return [hours, minutes, seconds];
            case "[HH,mm]":
                return [hours, minutes];
            case "yyyyMMddHHmmss":
                return `${year}${month}${day}${hours}${minutes}${seconds}`;
            default:
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    }


    /**
     * 屏幕截图转换到Base64
     */
    public static CaptureToBase64Async(dom: HTMLElement): Promise<{
        flag: boolean,
        imageBase64: string
    }> {
        return new Promise(r => {
            try {
                html2canvas(dom!, {
                    useCORS: true
                }).then(canvas => {
                    // 将截图转换为 Base64 数据 URL
                    const dataUrl = canvas.toDataURL('image/png');
                    dataUrl.Log("截图", ColorEnum.Success);
                    r({
                        flag: true,
                        imageBase64: dataUrl
                    });
                }).catch(() => {
                    r({
                        flag: false,
                        imageBase64: ''
                    })
                })
            }
            catch (ex) {
                r({
                    flag: false,
                    imageBase64: ""
                })
            }
        });
    }

    /**
     * 获取最大公约数
     * @param a
     * @param b 
     */
    private static GCD(width: number, height: number) {
        while (height !== 0) {
            const remainder = width % height; // 计算余数
            width = height; // 将 b 赋值给 a
            height = remainder; // 将余数赋值给 b
        }
        return width; // 返回最大公约数
    }

    /**
     * 获取分辨率比例
     * @param width 
     * @param height 
     */
    public static GetAspectRatio(width: number, height: number) {
        const divisor = this.GCD(width, height);
        const ratioWidth = width / divisor;
        const ratioHeight = height / divisor;
        return {
            ratioWidth,
            ratioHeight
        }
    }

    /**
     * 显示Loading
     */
    public static ShowLoading(message: string = '加载中...') {
        const callSetMessageFun = this.GetAppFun(Global.app!.LoadingRef!, "SetLoadingMessage");
        callSetMessageFun && callSetMessageFun(message);
        Global.app && this.CallAppFun(Global.app!.LoadingRef!, "Show");
    }
    /**
     * 隐藏Loading
     */
    public static HideLoading() {
        Global.app && this.CallAppFun(Global.app!.LoadingRef!, "Hide");
    }

    /**
     * 设置Loaidng的消息
     */
    public static SetLoadingMessage(message: string) {
        this.GetAppFun(Global.app!.LoadingRef!, "SetLoadingMessage")(message);
    }

    /**
     * 显示Loading
     */
    public static async ShowLoadingAsync(callAsync: (m: (loadingMessage: string) => void) => Promise<void>) {
        try {
            this.ShowLoading();

            const callSetMessageFun = this.GetAppFun(Global.app!.LoadingRef!, "SetLoadingMessage");
            callSetMessageFun && callSetMessageFun("加载中...");

            callAsync && await callAsync(callSetMessageFun);

        }
        catch (ex) {

        }
        finally {
            this.HideLoading();

        }
    }

    /**
     * 调用APP函数
     */
    private static CallAppFun<T>(obj: T, key: keyof T, ...param: any[]) {
        let fun = null;
        if (isRef(obj)) {
            fun = (obj.value as any)[key];
        }
        else {
            fun = (obj as any)[key];
        }
        return fun && fun(...param);
    }

    /**
     * 获取APP的函数
     */
    public static GetAppFun<T>(obj: T, key: keyof T) {
        let fun = null;
        if (isRef(obj)) {
            fun = (obj.value as any)[key];
        }
        else {
            fun = (obj as any)[key];
        }
        return fun;
    }

    private static colorPool = [
        "#FF5733", "#33FF57", "#3357FF", "#FF33A8", "#FFC733",
        "#57FFC7", "#A833FF", "#33FFF7", "#F7FF33", "#FF5733",
        "#33A8FF", "#A8FF33", "#5733FF", "#C7FF57", "#FFA833"
    ];


    /**
     * 获取颜色
     * @param index 
     */
    public static GetColorIndex(index: number): string {
        // const poolSize = this.colorPool.length;
        // return this.colorPool[index % poolSize];
        return '#1E1E1E';
    }

    /**
     * 文本预处理(递归切割)
     * @param outout 要输出的文本数组
     * @param text 文本内容
     * @param cutIdentifier 切割内容
     */

    public static TextPreprocessing(output: string[], text: string, cutIdentifiers: string[]): void {
        if (cutIdentifiers.length == 0) {
            if (Tools.IsNotNull(text))
                output.push(text);
            return;
        }
        const cut_char = cutIdentifiers[0];
        const arr = text.split(cut_char);
        for (let k = 0; k < arr.length; k++) {
            Tools.TextPreprocessing(output, arr[k], cutIdentifiers.slice(1))
        }
    }

    /**
     * 根据URL获取文件名称
     * @param url 
     * @returns 
     */
    public static GetFileNameFromURL(url: string) {
        // 首先通过 / 分割 URL
        const parts = url.split('/');
        // 获取分割后数组的最后一项，即可能包含文件名及参数的部分
        let fileName = parts[parts.length - 1];
        // 去除可能存在的查询参数
        fileName = fileName.split('?')[0];
        // 去除可能存在的哈希值
        fileName = fileName.split('#')[0];
        return fileName;
    }
}